import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeControlService } from 'pr1-ui-components';

@Component({
  selector: 'app-promo-assets',
  templateUrl: './promo-assets.component.html',
  styleUrls: ['./promo-assets.component.scss'],
})

export class PromoAssetsComponent implements OnInit {
  promoId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authorizationService: AuthorizeControlService
  ) { }

  ngOnInit(): void {
    this.promoId = this.route.snapshot.params['offerId'];
  }

  cancel(): void {
    this.router.navigate([`../../../`], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }
}
